import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-1263865e")
const _hoisted_1 = {
  key: 0,
  class: /*#__PURE__*/_normalizeClass({
    cardList:true,
  })
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1)
const _hoisted_3 = {
  key: 0,
  class: "moreToCome"
}
const _hoisted_4 = ["onClick", "data-focus"]
const _hoisted_5 = { class: "number" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "dot" }, null, -1)
const _hoisted_7 = { class: "text" }
const _hoisted_8 = {
  key: 0,
  class: "points"
}
const _hoisted_9 = { class: "icon" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "dot" }, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "text" }, [
  /*#__PURE__*/_createElementVNode("h4", null, "Exit door")
], -1)
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Ripple = _resolveComponent("Ripple")!
  const _component_MovingIcon = _resolveComponent("MovingIcon")!

  return ((_ctx.$store.state.GameView.lobby.playthrough.currentCard !== undefined))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        (_ctx.$store.state.GameView.lobby.playthrough.currentCard != _ctx.$store.state.GameView.cards.data.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cards, (card, index) => {
          return (_openBlock(), _createElementBlock(_Fragment, null, [
            (_ctx.$store.state.GameView.lobby.playthrough.currentCard >= card.index)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: _normalizeClass({card:true,active:_ctx.$store.state.GameView.currentFocus.id == card.id}),
                  onClick: ($event: any) => (_ctx.navigateToCard(card)),
                  "data-focus": `${card.id}`
                }, [
                  _createVNode(_component_Ripple),
                  _createElementVNode("div", _hoisted_5, _toDisplayString(card.index+1), 1),
                  _hoisted_6,
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("h4", null, _toDisplayString(card.title || "Untitled"), 1),
                    (_ctx.cardStatus && _ctx.cardStatus[card.id] && _ctx.cardStatus[card.id].complete && card.notes)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                          _createElementVNode("div", null, _toDisplayString(card.notes), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ], 10, _hoisted_4))
              : _createCommentVNode("", true)
          ], 64))
        }), 256)),
        (_ctx.$store.state.GameView.lobby.playthrough.atdoor)
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: _normalizeClass({card:true, door:true, active:_ctx.$store.state.GameView.currentFocus == 'door'}),
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.navigateToDoor())),
              "data-focus": `door`
            }, [
              _createVNode(_component_Ripple),
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_MovingIcon, {
                  name: "door",
                  type: "svg"
                })
              ]),
              _hoisted_10,
              _hoisted_11
            ], 2))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}